export function getPhaseNameTranslation({
  translator: {
    __
  },
  tld_phase
}) {
  if (tld_phase === 'golive') return __('General availability');
  if (tld_phase === 'landrush') return __('Landrush');
  if (tld_phase === 'sunrise') return __('Sunrise');
  if (tld_phase.match(/^eap\d{1}/)) {
    const current = tld_phase.replace(/\D+/, '');
    return __('Early Access Period - Day %(current)s', {
      current
    });
  }
  return tld_phase;
}
export function shouldShowPhase(payload) {
  if (!payload.tld_phase) return false;
  if (payload.tld_phase !== 'golive') return true;
  const startsAt = payload.phase_date_start;
  if (startsAt) {
    const now = new Date();
    const start = new Date(startsAt);
    return now <= start;
  }
  return false;
}